import React, { Component, createContext } from 'react';

const AuthModalContext = createContext({
  isOpen: false,
  activeTab: 'login',
  openAuthModal: () => {},
  closeAuthModal: () => {},
});

class AuthModalProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      activeTab: 'login',
      onSuccessCallback: null,
    };
    this.openAuthModal = this.openAuthModal.bind(this);
    this.closeAuthModal = this.closeAuthModal.bind(this);
  }

  openAuthModal(tab, onSuccessCallback) {
    document.body.style.overflow = 'hidden';
    this.setState({
      isOpen: true,
      activeTab: tab || 'login',
      onSuccessCallback: onSuccessCallback || null,
    });
  }

  closeAuthModal() {
    document.body.style.overflow = '';
    this.setState({
      isOpen: false,
      onSuccessCallback: null,
    });
  }

  render() {
    const { isOpen, activeTab, onSuccessCallback } = this.state;
    return (
      <AuthModalContext.Provider
        value={{
          isOpen,
          activeTab,
          onSuccessCallback,
          openAuthModal: this.openAuthModal,
          closeAuthModal: this.closeAuthModal,
        }}
      >
        {this.props.children}
      </AuthModalContext.Provider>
    );
  }
}

export { AuthModalProvider };
export default AuthModalContext;
